import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { NgClass } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TooltipModule } from 'primeng/tooltip';
import { NavItem } from '@fy-web-2/shared-util';
import { LayoutService } from '../layout.service';

@Component({
  selector: 'lib-sidebar',
  standalone: true,
  imports: [NgClass, RouterLink, RouterLinkActive, TooltipModule],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarComponent {
  private readonly layout = inject(LayoutService);

  /**
   * Menu entries to render. Provided by the App shell (or any parent
   * component) — typically derived from `NavigationFacade.navItems()`.
   * Keeping this as a component input means `ui-layout` (type:ui) does not
   * depend on `state-auth` (type:state), respecting Nx module boundaries.
   */
  readonly items = input<readonly NavItem[]>([]);

  protected readonly collapsed = this.layout.sidebarCollapsed;
  protected readonly widthClass = this.layout.sidebarWidthClass;
}
